module.exports = __webpack_public_path__ + "img/hemline kangaroo pocket position.690b5fbd.png";